/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Badge } from "@farmlands/shadcn-ui";

interface PromotionBadgeProps {
  label: string;
}

export const PromotionBadge = ({ label }: PromotionBadgeProps) => (
  <Badge style={{ backgroundColor: colors["secondary600"] }}>{label}</Badge>
);
